// extracted by mini-css-extract-plugin
export default {"wrapper":"NumberInput_wrapper__-GOEH","item":"NumberInput_item__tWEoh","itemInput":"NumberInput_itemInput__944TU","select":"NumberInput_select__sfDbX"};